import { render, staticRenderFns } from "./RadioGroupInput.vue?vue&type=template&id=ecd2b8f4"
import script from "./RadioGroupInput.vue?vue&type=script&lang=js"
export * from "./RadioGroupInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports